import { render } from "./BasicInput.vue?vue&type=template&id=5808a406&scoped=true"
import script from "./BasicInput.vue?vue&type=script&lang=js"
export * from "./BasicInput.vue?vue&type=script&lang=js"

import "./BasicInput.vue?vue&type=style&index=0&id=5808a406&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5808a406"]])

export default __exports__